



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import Input2PasswordInput from '../../html-components-type-1-basic/basic-type-3-input/input-2-password-input.vue'
import UserInterface3ErrorMessage from '../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-3-error-message.vue'

// const namespace = 'digitalCurrency'

@Component({
  components: {
    Input2PasswordInput,
    UserInterface3ErrorMessage
  }
})
class DigitalCurrency18AccountSignInIntroduction extends Vue {

  @Prop({ default: '' }) accountId?: string

  @State('serviceAccount') serviceAccount?: any

  @Action('initializeServiceAccount') initializeServiceAccount?: any
  @Action('createServiceAccount') createServiceAccount?: any
  @Action('createServiceAccountRecoveryMessage') createServiceAccountRecoveryMessage?: any

  visibleDialogContent = 'sign-in'

  signInContentType = 'sign-in'
  createAccountContentType = 'create-account'
  passwordRecoveryContentType = 'password-recovery'

  signInEmailAddress: string = ''
  signInPassword: string = ''

  isValidSignInForm: boolean = false

  createAccountEmailAddress: string = ''
  createAccountPassword1: string = ''
  createAccountPassword2: string = ''

  isValidCreateAccountForm: boolean = false

  passwordRecoveryEmailAddress: string = ''

  isValidPasswordRecoveryForm: boolean = false

  showErrorMessage: boolean = false
  errorMessage: string = ''

  async signInWithGoogle () {
    try {
      await this.initializeServiceAccount({
        isGoogleSignIn: true
      })
    } catch (errorMessage: any) {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
      return
    }
    this.emitToggleShowContent({ isVisible: false })
  }

  async signInWithEmailAndPassword () {
    if (!this.isValidSignInForm) {
      return
    }

    try {
      await this.initializeServiceAccount({
        isEmailAndPasswordSignIn: true,
        emailAddress: this.signInEmailAddress,
        password: this.signInPassword
      })
    } catch (errorMessage: any) {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
      return
    }

    this.emitToggleShowContent({ isVisible: false })

    ;(this.$refs['signInForm'] as any).reset()
  }

  async createAccount () {
    if (!this.isValidCreateAccountForm) {
      return
    }

    try {
      await this.createServiceAccount({
        emailAddress: this.createAccountEmailAddress,
        password: this.createAccountPassword1,
        linkWithExistingAccount: this.serviceAccount.isAnonymousAccount
      })
    } catch (errorMessage: any) {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
      return
    }

    this.emitToggleShowContent({ isVisible: false })

    ;(this.$refs['createAccountForm'] as any).reset()

    this.visibleDialogContent = this.signInContentType
  }

  async sendPasswordResetLink () {
    if (!this.isValidPasswordRecoveryForm) {
      return
    }

    await this.createServiceAccountRecoveryMessage({
      emailAddress: this.passwordRecoveryEmailAddress
    })

    ;(this.$refs['passwordRecoveryForm'] as any).reset()

    this.visibleDialogContent = this.signInContentType
  }

  requireInput (inputValue: any) {
    return !!inputValue || 'Must have input value'
  }

  requireMoreThanN1Characters (inputValue: any) {
    return inputValue.length >= 5 || 'Must have at least than 5 characters'
  }

  requirePassword1AndPassword2Match (inputValue: any) {
    return inputValue === this.createAccountPassword1 || 'Must match password'
  }

  requireValidEmailAddress (inputValue: any) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(inputValue) || 'Must be valid email address'
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }
}

export default DigitalCurrency18AccountSignInIntroduction


